module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-root"
  }, [_c('general-title', {
    attrs: {
      "title": "热力图",
      "description": "热力图通过颜色区分为您展示您网站页面的点击情况，帮助对用户点击行为分析，优化页面设计。",
      "pos": "right"
    }
  }, [_c('div', {
    staticClass: "btn btn-primary btn-big pull-right add-site",
    on: {
      "click": _vm.addNewURL
    }
  }, [_vm._v("添加新热力图")])]), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "热力图列表"
    }
  }), _c('table', {
    staticClass: "data-table",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [_vm._m(0), _c('tbody', [_vm._l((_vm.tableList), function(item, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isListLoading && _vm.tableList.length),
        expression: "!isListLoading && tableList.length"
      }],
      key: item.id
    }, [_c('td', {
      attrs: {
        "width": "40"
      }
    }), _c('td', {
      staticClass: "ta-l"
    }, [_vm._v(_vm._s(item.pagename))]), _c('td', {
      staticClass: "ta-l"
    }, [_c('cite', {
      attrs: {
        "title": _vm._f("httpUrl")(item.url)
      }
    }, [_vm._v(_vm._s(_vm._f("httpUrl")(item.url)))])]), _c('td', [_vm._v(_vm._s(item.createtime))]), _c('td', [_c('VueSwitch', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.bstatus),
        expression: "item.bstatus"
      }],
      staticStyle: {
        "display": "inline-block",
        "vertical-align": "middle"
      },
      attrs: {
        "bind": false,
        "open-name": "开启",
        "open-value": "1",
        "close-name": "暂停",
        "close-value": "0",
        "color": "green",
        "size": "lg"
      },
      domProps: {
        "value": (item.bstatus)
      },
      on: {
        "change": function($event) {
          _vm.changeItemBstate(item, $event)
        },
        "input": function($event) {
          item.bstatus = $event
        }
      }
    })], 1), _c('td', [_c('i', {
      staticClass: "fa fa-eye fa-lg",
      attrs: {
        "title": "查看"
      },
      on: {
        "click": function($event) {
          _vm.openHeatmap(item)
        }
      }
    })]), _c('td', {
      staticClass: "operate-cell"
    }, [_c('i', {
      staticClass: "fa fa-edit fa-lg",
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          _vm.openEdit(item)
        }
      }
    }), _c('i', {
      staticClass: "fa fa-trash-o fa-lg",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          _vm.deleteItem(item)
        }
      }
    })])])
  }), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isListLoading && _vm.tableList.length === 0),
      expression: "!isListLoading && tableList.length === 0"
    }]
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("暂无数据")])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isListLoading),
      expression: "isListLoading"
    }]
  }, [_vm._m(1)])], 2)])], 1), _vm._m(2), _c('v-modal', {
    attrs: {
      "visible": _vm.modalVisible,
      "title": _vm.modalStatus === 'new' ? '新增热力图' : '编辑热力图配置'
    },
    on: {
      "closemodal": function($event) {
        _vm.modalVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "600px"
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('dl', {
    staticClass: "item"
  }, [_c('dt', {
    staticClass: "label"
  }, [_vm._v("页面名称")]), _c('dd', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteModel.pagename),
      expression: "siteModel.pagename"
    }],
    ref: "pnameInput",
    staticClass: "size-big size-normal",
    attrs: {
      "placeholder": "请输入1-50字符名称"
    },
    domProps: {
      "value": _vm._s(_vm.siteModel.pagename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.siteModel.pagename = $event.target.value
      }
    }
  }), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.heatSiteError.pagename.oversize),
      expression: "heatSiteError.pagename.oversize"
    }],
    staticClass: "error"
  }, [_vm._v("最多填写50个字符")])])]), _c('dl', {
    staticClass: "item"
  }, [_c('dt', {
    staticClass: "label"
  }, [_vm._v("页面URL")]), _c('dd', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteModel.url),
      expression: "siteModel.url"
    }],
    ref: "urlInput",
    staticClass: "size-big size-normal",
    attrs: {
      "placeholder": "请输入URL 如：http://aaa.com，可通配"
    },
    domProps: {
      "value": _vm._s(_vm.siteModel.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.siteModel.url = $event.target.value
      }
    }
  }), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.heatSiteError.url.invalid && _vm.heatSiteError.url.oversize),
      expression: "!heatSiteError.url.invalid && heatSiteError.url.oversize"
    }],
    staticClass: "error"
  }, [_vm._v("长度不得大于 1000")]), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.heatSiteError.url.invalid),
      expression: "heatSiteError.url.invalid"
    }],
    staticClass: "error"
  }, [_vm._v("请输入正确格式的 URL")])])]), _c('dl', {
    staticClass: "item"
  }, [_c('dt', {
    staticClass: "label"
  }, [_vm._v("设置网页在浏览器中显示位置")]), _c('dd', {
    staticClass: "control"
  }, [_c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteModel.location),
      expression: "siteModel.location"
    }],
    attrs: {
      "options": [{
        title: '居左',
        value: 0
      }, {
        title: '居中',
        value: 1
      }, {
        title: '居右',
        value: 2
      }]
    },
    domProps: {
      "value": (_vm.siteModel.location)
    },
    on: {
      "input": function($event) {
        _vm.siteModel.location = $event
      }
    }
  })], 1)]), _c('div', {
    staticClass: "mutil-expr"
  }, [_c('p', {
    staticClass: "ellipsis"
  }, [_vm._v("若您的页面对应多个链接或者您想要统计一组页面，请"), _c('cite', {
    on: {
      "click": _vm.toggleModalExt
    }
  }, [_vm._v("设置统计范围"), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.siteModel.showExt),
      expression: "!siteModel.showExt"
    }],
    staticClass: "arrow"
  }, [_vm._v("▸")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.siteModel.showExt),
      expression: "siteModel.showExt"
    }],
    staticClass: "arrow"
  }, [_vm._v("▾")])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.siteModel.showExt),
      expression: "siteModel.showExt"
    }]
  }, [_c('p', {
    staticClass: "ellipsis"
  }, [_vm._v("当前展示页面："), _c('cite', {
    attrs: {
      "title": _vm.siteModel.url
    }
  }, [_vm._v(_vm._s(_vm.siteModel.url))])]), _c('p'), _c('dt', {
    staticClass: "label"
  }, [_vm._v("统计页面：")]), _c('dd', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteModel.ext_url),
      expression: "siteModel.ext_url"
    }],
    staticClass: "size-big size-normal",
    attrs: {
      "placeholder": "请输入URL 如：http://aaa.com，可通配"
    },
    domProps: {
      "value": _vm._s(_vm.siteModel.ext_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.siteModel.ext_url = $event.target.value
      }
    }
  }), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.heatSiteError.ext_url.invalid),
      expression: "heatSiteError.ext_url.invalid"
    }],
    staticClass: "error"
  }, [_vm._v("请输入正确格式的 URL")]), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.heatSiteError.ext_url.invalid && _vm.heatSiteError.ext_url.oversize),
      expression: "!heatSiteError.ext_url.invalid && heatSiteError.ext_url.oversize"
    }],
    staticClass: "error"
  }, [_vm._v("长度不得大于 1000")]), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.heatSiteError.ext_url.empty && !_vm.heatSiteError.ext_url.invalid && !_vm.heatSiteError.ext_url.oversize && _vm.asteriskAbsent),
      expression: "!heatSiteError.ext_url.empty && !heatSiteError.ext_url.invalid && !heatSiteError.ext_url.oversize && asteriskAbsent"
    }],
    staticClass: "error"
  }, [_vm._v("未包含通配符")])]), _c('p'), _c('p', {
    staticClass: "tip"
  }, [_c('span', [_vm._v("统计一组页面的数据需要在URL中使用 * 进行通配")]), _c('v-tooltip', {
    attrs: {
      "tip": "若您想监测某注册完成页http://www.aaa.com/sign_up/id=xxx，不同访客有不同id，则目标页面可设置为http://www.aaa.com/sign_up/id=*；若您想监测某页面不同渠道的流量来源数据，可将该目标页面设置为http://www.aaa.com/*。",
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa fa-question-circle"
  })])], 1)])]), _c('div', {
    staticClass: "modal-tip"
  }, [_vm._v("注意：请在所有想统计的页面上安装360分析代码")])])]), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-small",
    class: {
      disabled: !_vm.canSubmit
    },
    attrs: {
      "type": "button",
      "value": "提交"
    },
    on: {
      "click": function($event) {
        _vm.submitModal(_vm.siteModel)
      }
    }
  }), _c('input', {
    staticClass: "btn btn-default btn-small",
    attrs: {
      "type": "button",
      "value": "取消"
    },
    on: {
      "click": function($event) {
        _vm.modalVisible = false
      }
    }
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "40"
    }
  }), _c('th', {
    staticClass: "ta-l",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("页面名称")]), _c('th', {
    staticClass: "ta-l",
    attrs: {
      "width": "100%"
    }
  }, [_vm._v("页面URL")]), _c('th', {
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("创建时间")]), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("统计状态")]), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("查看热力图")]), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("操作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('img', {
    attrs: {
      "src": "//p.ssl.qhimg.com/t010aba4345b02168d6.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "desc-text"
  }, [_vm._v("说明"), _c('br'), _vm._v("1 最多对10个页面进行监测。"), _c('br'), _vm._v("2 新增热力图时，请确保监测页面已添加360分析代码且已生效。")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1557ce68", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1557ce68!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/heatlist.vue
// module id = 715
// module chunks = 0